export default function alwaysTrue(): true {
  return true
}